import { Badge, Box } from '@palmetto/palmetto-components';
import { Link } from 'react-router-dom';

import { SalesRepStatus, salesRepStatusLabels } from 'types';

import { salesRepStatusBadgeVariant } from '../../SalesReps/statusBadge';

import EventBy from './EventBy';

const SABAL_SALES_REP_ENTITY = 'sabalSalesRep';

const StatusBadge = ({ status }: { status?: string }) => (
  <Badge
    variant={status ? (salesRepStatusBadgeVariant[status as SalesRepStatus] ?? 'default') : 'default'}
    message={status ? (salesRepStatusLabels[status as SalesRepStatus] ?? status) : '—'}
  />
);

const SalesRepStatusChanged = ({ event }: { event: any }) => {
  const fromStatus = event?.data?.diff?.from?.status as string | undefined;
  const toStatus = event?.data?.diff?.to?.status as string | undefined;
  const salesRepName = event?.data?.diff?.affected?.salesRepName as string | undefined;
  const salesRepId = event?.associatedEntities?.find((e: any) => e.type === SABAL_SALES_REP_ENTITY)?.id;
  const recheckId = event?.data?.diff?.affected?.recheckId as string | undefined;
  const reason = event?.data?.reason as string | undefined;
  return (
    <Box display="block">
      <Box direction="column">
        <Box direction="row" alignItems="center" childGap="xs" flex="auto">
          <EventBy event={event} />
          <Box as="span" color="body-secondary">
            &nbsp; changed sales rep status {salesRepName ? `for ${salesRepName}` : ''}{' '}
            {recheckId ? `(ID:${recheckId})` : ''} from
          </Box>
          <StatusBadge status={fromStatus} />
          <Box as="span" color="body-secondary">
            →
          </Box>
          <StatusBadge status={toStatus} />
          {salesRepId ? (
            <Box as="span" fontSize="xs" margin="0 0 0 sm">
              <Link to={`/admin/sales-reps/${salesRepId}`}>View rep</Link>
            </Box>
          ) : null}
        </Box>
        {reason ? (
          <Box as="span" color="body-secondary" fontSize="xs" margin="2xs 0 0 0">
            Reason: {reason}
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};

export default SalesRepStatusChanged;
